import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import MuiCard from '@mui/material/Card';
import FormControl from '@mui/material/FormControl';
import Link from '@mui/material/Link';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { useLocation, useNavigate } from 'react-router-dom';
import Content from '../content/Content';
import { styled } from '@mui/material/styles';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { Alert, Divider, FilledInput, FormControlLabel, FormLabel, Grid, IconButton, InputAdornment, InputLabel, Snackbar } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

const API = require("../../data/network/API");

function Copyright(props) {
  return (
    <Stack spacing={4} sx={{mt:2}}>
      <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {new Date().getFullYear()} {'© SwitchPoint SA. de CV. All rights reserved'}
      </Typography>
      <Box
          alignSelf= 'center'
          component="img"
          sx={{
            height: 32,
            width: 80,
          }}
          alt="officia logo."
          src="/static/sw.png"
        />
    </Stack>
  );
}

const Card = styled(MuiCard)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'center',
  width: '100%',
  padding: theme.spacing(4),
  backgroundColor: 'transparent',
  gap: theme.spacing(2),
  boxShadow:
    'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
  [theme.breakpoints.up('sm')]: {
    width: '450px',
  },
  ...theme.applyStyles('dark', {
    boxShadow:
      'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
  }),
}));

function RegistryCard() {
  const navigate = useNavigate();
  const {state} = useLocation();

  const [snackbarState, setSnackbarState] = React.useState({open:false,message:"",status:"info"});
  const [loader, setLoader] = React.useState(null)
  const [gender, setGender] = React.useState('male');

  const handleChange = (event) => {
    setGender(event.target.value);
  };

  
  const handleSubmit = async(event) => {
    event.preventDefault();

    const data = new FormData(event.currentTarget);

    const name = data.get('name')
    const last_name = data.get('last_name')
    const phone = data.get('phone')

    if(name.length==0||last_name.length==0||phone.length==0||gender.length==0){
        setSnackbarState({open:true,message:"Por favor llena todos los campos.",status:"warning"})
        return
    }

    const requestBody = {
        id_usuario: state.id_usuario,
        telefono: phone,
        nombre: name,
        genero: gender,
        apellido_paterno: last_name
    }

    setLoader(true);
    const response = await API.postProfile(requestBody)
    setLoader(false);

    if (response.status == 200){
        console.log(response.data)
        navigate('/');
    } else {
        setSnackbarState({open:true, message: response.message, status:"error"})
    }
  };

  const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
    setSnackbarState({open:false,message:snackbarState.message,status:snackbarState.status})
  };

  return (
    <Card >
        <Box
            alignSelf= 'center'
            component="img"
            sx={{
            height: 56,
            width: 56,
            }}
            alt="officia logo."
            src="/static/logo_guna.png"
        />
       <Box
            alignSelf= 'center'
            component="img"
            sx={{
            height: 256,
            width: 256,
            }}
            alt="officia logo."
            src="/static/sign_in_ background.png"
        />
      <Typography
        component="h5"
        variant="h5"
      >
        Perfil
      </Typography>
      <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1 }}>
        
        <TextField
          margin="normal"
          required
          fullWidth
          id="name"
          label="Nombre"
          name="name"
          autoComplete="name"
          variant="filled"
          autoFocus
          color='secondary'
        />
         <TextField
          margin="normal"
          required
          fullWidth
          id="last_name"
          label="Apellido paterno"
          name="last_name"
          autoComplete="last_name"
          variant="filled"
          autoFocus
          color='secondary'
        />
        <TextField
          margin="normal"
          required
          fullWidth
          id="phone"
          label="Telefono"
          name="phone"
          autoComplete="phone"
          variant="filled"
          autoFocus
          color='secondary'
        />
        <FormControl>
            <FormLabel id="demo-row-radio-buttons-group-label" disabled={true} sx={{pt:2}}>Genero</FormLabel>
            <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={gender}
                onChange={handleChange}
              
            >
                <FormControlLabel value="female" control={<Radio  color='secondary'/>} label="Female" />
                <FormControlLabel value="male" control={<Radio color='secondary'/>} label="Male" />
                <FormControlLabel value="other" control={<Radio color='secondary'/>} label="Other" />
            </RadioGroup>
        </FormControl>
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color='secondary'
          sx={{ mt: 3, mb: 2 }}
        >
          Continuar
        </Button>
        <Grid container>
          <Grid item xs>
            <Stack spacing={2}>
              <Typography variant="body2" color="text.secondary" align="center">
              Al continuar, aceptar nuestras condiciones de uso y venta.
              </Typography>
              <Typography align='center'>
                <Link href="/privacy" variant="body2" color={"secondary"} >
                  Aviso de privicidad
                </Link>
              </Typography>
            </Stack>
          </Grid>
          <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={snackbarState.open} onClose={handleClose}>
            <Alert
              onClose={handleClose}
              severity={snackbarState.status}
              variant="filled"
            >
              {snackbarState.message}
            </Alert>
          </Snackbar>
        </Grid>
        <Copyright/>
      </Box> 
    </Card>
  );
}

export default function RegistryProfile() {
  return (
    <>
      <CssBaseline enableColorScheme />
      <Stack
        direction="column"
        component="main"
        sx={[
          {
            justifyContent: 'center',
            height: 'calc((1 - var(--template-frame-height, 0)) * 100%)',
            //marginTop: 'max(40px - var(--template-frame-height, 0px), 0px)',
            minHeight: '100%',
          },
        ]}
      >
        <Stack
          direction={{ xs: 'column-reverse', md: 'row' }}
          sx={{
            justifyContent: 'center',
            gap: { xs: 6, sm: 12 },
            mx: 'auto',
          }}
        >
          <Stack
            direction={{ xs: 'column-reverse', md: 'row' }}
            sx={{
              justifyContent: 'center',
              gap: { xs: 6, sm: 12 },
              p: { xs: 0, sm: 4 },
              m: 'auto',
            }}
          >
            <Content />
            <RegistryCard />
          </Stack>
        </Stack>
      </Stack>
    </>
  );
}